import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "text-muted mt-1 fw-semobold fs-7" }
const _hoisted_5 = { class: "ms-3" }
const _hoisted_6 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_7 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = {
  key: 0,
  class: "alert alert-info d-flex align-items-center mb-5 mx-9",
  role: "alert"
}
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = { class: "row mb-5" }
const _hoisted_14 = { class: "col-md-6 mb-2" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = { class: "col-md-3 mb-2" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 1,
  class: "bi bi-arrow-clockwise me-2"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "col-md-3 mb-2" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "text-muted me-3" }
const _hoisted_25 = { class: "card-body pt-0" }
const _hoisted_26 = { class: "table-responsive" }
const _hoisted_27 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_28 = { class: "fw-semibold text-gray-600" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  colspan: "10",
  class: "text-center py-5"
}
const _hoisted_32 = { class: "d-flex flex-column align-items-center" }
const _hoisted_33 = { class: "text-gray-500 mb-3" }
const _hoisted_34 = {
  key: 0,
  class: "d-flex gap-2"
}
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "symbol symbol-circle symbol-50px overflow-hidden me-3" }
const _hoisted_37 = { class: "symbol-label bg-light-primary" }
const _hoisted_38 = { class: "svg-icon svg-icon-2x" }
const _hoisted_39 = { class: "d-flex flex-column" }
const _hoisted_40 = { class: "text-gray-800 mb-1" }
const _hoisted_41 = { class: "text-dark fw-semibold" }
const _hoisted_42 = { class: "d-flex flex-column" }
const _hoisted_43 = { class: "text-dark fw-semibold" }
const _hoisted_44 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_45 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_46 = {
  class: "text-success fw-semibold",
  title: "Burung masuk hari ini"
}
const _hoisted_47 = {
  class: "text-danger fw-semibold",
  title: "Burung keluar hari ini"
}
const _hoisted_48 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = { class: "text-dark fw-semibold me-2" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 0,
  class: "badge badge-light-dark",
  title: "Siaran diputus — kamera tidak streaming"
}
const _hoisted_53 = { class: "form-check form-switch form-check-custom form-check-solid mb-2" }
const _hoisted_54 = ["checked", "disabled", "onChange", "id"]
const _hoisted_55 = ["for"]
const _hoisted_56 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["title"]
const _hoisted_59 = ["checked", "disabled", "onChange", "id"]
const _hoisted_60 = ["for"]
const _hoisted_61 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_64 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_65 = { class: "text-dark fw-semibold" }
const _hoisted_66 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_67 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_68 = { class: "d-flex flex-column" }
const _hoisted_69 = { class: "text-dark fw-semibold" }
const _hoisted_70 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_71 = { class: "text-end" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "svg-icon svg-icon-3" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { class: "svg-icon svg-icon-3" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "svg-icon svg-icon-3" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "svg-icon svg-icon-3" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = ["onClick"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "svg-icon svg-icon-3" }
const _hoisted_87 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center flex-wrap mt-5"
}
const _hoisted_88 = { class: "d-flex flex-wrap py-2 mr-3" }
const _hoisted_89 = { class: "text-muted" }
const _hoisted_90 = { class: "d-flex flex-wrap py-2" }
const _hoisted_91 = { class: "pagination" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = {
  class: "modal fade",
  id: "deviceModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = { class: "modal-header" }
const _hoisted_97 = { class: "modal-title" }
const _hoisted_98 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_99 = { class: "svg-icon svg-icon-2x" }
const _hoisted_100 = { class: "modal-body" }
const _hoisted_101 = {
  key: 0,
  class: "alert alert-info d-flex align-items-center mb-4",
  role: "alert"
}
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { class: "mb-5" }
const _hoisted_105 = { class: "form-text" }
const _hoisted_106 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_107 = { class: "mb-5" }
const _hoisted_108 = { class: "form-text" }
const _hoisted_109 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_110 = { class: "row mb-5" }
const _hoisted_111 = { class: "col-md-6" }
const _hoisted_112 = { class: "col-md-6" }
const _hoisted_113 = { class: "mb-5" }
const _hoisted_114 = ["placeholder", "required"]
const _hoisted_115 = { class: "form-text" }
const _hoisted_116 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_117 = { class: "input-group" }
const _hoisted_118 = ["value"]
const _hoisted_119 = { class: "text-end" }
const _hoisted_120 = ["disabled"]
const _hoisted_121 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_122 = {
  class: "modal fade",
  id: "importDeviceModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_123 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_124 = { class: "modal-content" }
const _hoisted_125 = { class: "modal-header" }
const _hoisted_126 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_127 = { class: "svg-icon svg-icon-2x" }
const _hoisted_128 = { class: "modal-body" }
const _hoisted_129 = { class: "mb-5" }
const _hoisted_130 = { class: "mb-5" }
const _hoisted_131 = { class: "text-end" }
const _hoisted_132 = ["disabled"]
const _hoisted_133 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_134 = {
  key: 1,
  class: "bi bi-plus-circle me-2"
}
const _hoisted_135 = {
  class: "modal fade",
  id: "viewDeviceModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_136 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_137 = { class: "modal-content" }
const _hoisted_138 = { class: "modal-header" }
const _hoisted_139 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_140 = { class: "svg-icon svg-icon-2x" }
const _hoisted_141 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_142 = { class: "row" }
const _hoisted_143 = { class: "col-md-6" }
const _hoisted_144 = { class: "card bg-light mb-5" }
const _hoisted_145 = { class: "card-body" }
const _hoisted_146 = { class: "d-flex align-items-center mb-4" }
const _hoisted_147 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_148 = { class: "symbol-label bg-primary" }
const _hoisted_149 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_150 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_151 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_152 = { class: "text-gray-600 fw-semibold" }
const _hoisted_153 = { class: "d-flex align-items-center mb-4" }
const _hoisted_154 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_155 = { class: "symbol-label bg-success" }
const _hoisted_156 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_157 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_158 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_159 = { class: "text-gray-600 fw-semibold" }
const _hoisted_160 = { class: "d-flex align-items-center mb-4" }
const _hoisted_161 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_162 = { class: "symbol-label bg-warning" }
const _hoisted_163 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_164 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_165 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_166 = { class: "text-gray-600 fw-semibold" }
const _hoisted_167 = {
  key: 0,
  class: "text-gray-500 fs-7"
}
const _hoisted_168 = { class: "col-md-6" }
const _hoisted_169 = { class: "card bg-light mb-5" }
const _hoisted_170 = { class: "card-body" }
const _hoisted_171 = { class: "d-flex align-items-center mb-4" }
const _hoisted_172 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_173 = { class: "symbol-label bg-info" }
const _hoisted_174 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_175 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_176 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_177 = { class: "d-flex align-items-center" }
const _hoisted_178 = { class: "text-gray-600 fw-semibold me-2" }
const _hoisted_179 = { class: "d-flex align-items-center mb-4" }
const _hoisted_180 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_181 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_182 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_183 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_184 = { class: "text-gray-600 fw-semibold" }
const _hoisted_185 = { class: "d-flex align-items-center mb-4" }
const _hoisted_186 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_187 = { class: "symbol-label bg-dark" }
const _hoisted_188 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_189 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_190 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_191 = { class: "text-gray-600 fw-semibold" }
const _hoisted_192 = { class: "d-flex align-items-center mb-4" }
const _hoisted_193 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_194 = { class: "symbol-label bg-secondary" }
const _hoisted_195 = { class: "svg-icon svg-icon-1 svg-icon-white" }
const _hoisted_196 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_197 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_198 = { class: "text-gray-600 fw-semibold" }
const _hoisted_199 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_200 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_201 = { class: "modal-content" }
const _hoisted_202 = { class: "modal-header" }
const _hoisted_203 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_204 = { class: "svg-icon svg-icon-2x" }
const _hoisted_205 = { class: "modal-body" }
const _hoisted_206 = { class: "text-center" }
const _hoisted_207 = { class: "svg-icon svg-icon-warning svg-icon-3x" }
const _hoisted_208 = { class: "mt-5" }
const _hoisted_209 = { class: "text-muted" }
const _hoisted_210 = { class: "modal-footer" }
const _hoisted_211 = ["disabled"]
const _hoisted_212 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_213 = {
  class: "modal fade",
  id: "pairModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_214 = { class: "modal-dialog modal-dialog-centered mw-500px" }
const _hoisted_215 = { class: "modal-content" }
const _hoisted_216 = { class: "modal-header" }
const _hoisted_217 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_218 = { class: "svg-icon svg-icon-2x" }
const _hoisted_219 = { class: "modal-body" }
const _hoisted_220 = { key: 0 }
const _hoisted_221 = { class: "mb-3" }
const _hoisted_222 = { class: "mb-3" }
const _hoisted_223 = { class: "mb-3" }
const _hoisted_224 = {
  key: 0,
  class: "text-danger fs-8 mb-2"
}
const _hoisted_225 = ["disabled"]
const _hoisted_226 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_227 = {
  key: 1,
  class: "text-center"
}
const _hoisted_228 = { class: "d-inline-block p-3 bg-white rounded shadow-sm" }
const _hoisted_229 = { class: "badge badge-light-primary mt-3" }
const _hoisted_230 = ["disabled"]
const _hoisted_231 = {
  key: 2,
  class: "text-center"
}
const _hoisted_232 = { class: "mb-1" }
const _hoisted_233 = { class: "text-muted fs-7" }
const _hoisted_234 = { class: "alert alert-success text-start fs-8 mt-3" }
const _hoisted_235 = { key: 0 }
const _hoisted_236 = { key: 1 }
const _hoisted_237 = {
  class: "modal fade",
  id: "assignOwnerModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_238 = { class: "modal-dialog modal-dialog-centered mw-500px" }
const _hoisted_239 = { class: "modal-content" }
const _hoisted_240 = { class: "modal-header" }
const _hoisted_241 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_242 = { class: "svg-icon svg-icon-2x" }
const _hoisted_243 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_244 = { class: "text-muted fs-7 mb-4" }
const _hoisted_245 = { class: "mb-3" }
const _hoisted_246 = {
  key: 0,
  class: "form-text"
}
const _hoisted_247 = { class: "text-end" }
const _hoisted_248 = ["disabled"]
const _hoisted_249 = ["disabled"]
const _hoisted_250 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_251 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_252 = { class: "fs-7" }
const _hoisted_253 = ["onClick", "disabled"]
const _hoisted_254 = {
  key: 1,
  class: "text-muted fs-8 mb-3"
}
const _hoisted_255 = { class: "input-group" }
const _hoisted_256 = ["disabled"]
const _hoisted_257 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_258 = {
  class: "modal fade",
  id: "handoffModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_259 = { class: "modal-dialog modal-dialog-centered mw-500px" }
const _hoisted_260 = { class: "modal-content" }
const _hoisted_261 = { class: "modal-header" }
const _hoisted_262 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_263 = { class: "svg-icon svg-icon-2x" }
const _hoisted_264 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_265 = { class: "text-muted fs-7 mb-4" }
const _hoisted_266 = { class: "mb-3" }
const _hoisted_267 = {
  key: 0,
  class: "form-text"
}
const _hoisted_268 = { class: "mb-3" }
const _hoisted_269 = { class: "mb-3" }
const _hoisted_270 = { class: "text-end" }
const _hoisted_271 = ["disabled"]
const _hoisted_272 = ["disabled"]
const _hoisted_273 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_274 = {
  class: "modal fade",
  id: "watchDeviceModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_275 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_276 = { class: "modal-content" }
const _hoisted_277 = { class: "modal-header" }
const _hoisted_278 = { class: "modal-title" }
const _hoisted_279 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}
const _hoisted_280 = { class: "svg-icon svg-icon-2x" }
const _hoisted_281 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_282 = { class: "text-muted fs-8 mt-3 mb-0" }
const _hoisted_283 = { key: 0 }
const _hoisted_284 = { key: 1 }
const _hoisted_285 = { key: 2 }
const _hoisted_286 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_LiveStreamPlayer = _resolveComponent("LiveStreamPlayer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _cache[44] || (_cache[44] = _createElementVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "Perangkat IoT Walet", -1)),
          _createElementVNode("span", _hoisted_4, [
            _cache[43] || (_cache[43] = _createTextVNode("Kelola, pantau & tonton siaran langsung perangkat IoT walet. ", -1)),
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showInfo && _ctx.showInfo(...args)), ["prevent"])),
              class: "text-primary text-decoration-underline"
            }, "Info lebih lanjut"),
            _createElementVNode("span", _hoisted_5, [
              (_ctx.deviceApiService.hasAdminKey())
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[41] || (_cache[41] = [
                    _createElementVNode("i", { class: "bi bi-cloud-check me-1" }, null, -1),
                    _createTextVNode("Server Connected ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[42] || (_cache[42] = [
                    _createElementVNode("i", { class: "bi bi-cloud-slash me-1" }, null, -1),
                    _createTextVNode("Local Mode ", -1)
                  ]))]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPairModal && _ctx.openPairModal(...args))),
              class: "btn btn-sm btn-primary"
            }, [...(_cache[45] || (_cache[45] = [
              _createElementVNode("i", { class: "bi bi-qr-code me-2" }, null, -1),
              _createTextVNode(" Pasangkan Kamera (QR) ", -1)
            ]))]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAddDeviceModal && _ctx.openAddDeviceModal(...args))),
              class: "btn btn-sm btn-light-primary"
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
              ]),
              _cache[46] || (_cache[46] = _createTextVNode(" Daftar Baru ", -1))
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openImportDeviceModal && _ctx.openImportDeviceModal(...args))),
              class: "btn btn-sm btn-light-success"
            }, [...(_cache[47] || (_cache[47] = [
              _createElementVNode("i", { class: "bi bi-plus-circle me-2" }, null, -1),
              _createTextVNode(" Tambah yang Ada ", -1)
            ]))])
          ])
        ])
      ]),
      (_ctx.devices.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[48] || (_cache[48] = _createStaticVNode("<i class=\"bi bi-info-circle-fill me-3 fs-2\" data-v-287adde9></i><div class=\"flex-grow-1\" data-v-287adde9><h6 class=\"alert-heading mb-2\" data-v-287adde9> Selamat Datang di Manajemen Perangkat IoT! </h6><p class=\"mb-2\" data-v-287adde9>Untuk memulai, Anda dapat:</p><ul class=\"mb-2\" data-v-287adde9><li data-v-287adde9><strong data-v-287adde9>Daftar Perangkat Baru</strong> - Jika Anda memiliki perangkat IoT yang belum terdaftar </li><li data-v-287adde9><strong data-v-287adde9>Tambah yang Sudah Ada</strong> - Jika perangkat sudah terdaftar sebelumnya </li></ul><small class=\"text-muted\" data-v-287adde9><i class=\"bi bi-shield-check me-1\" data-v-287adde9></i> Data perangkat akan disimpan secara aman di browser Anda </small></div>", 2)),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showInfo && _ctx.showInfo(...args))),
              class: "btn btn-sm btn-light-primary ms-3"
            }, " Pelajari Lebih Lanjut ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "search",
                class: "form-control",
                placeholder: "Cari berdasarkan ID, nama, atau lokasi...",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.filterDevices && _ctx.filterDevices(...args))),
                name: "mw-device-search",
                autocomplete: "off",
                autocorrect: "off",
                autocapitalize: "off",
                spellcheck: "false",
                readonly: "",
                onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.removeAttribute('readonly')))
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _cache[49] || (_cache[49] = _createElementVNode("span", { class: "input-group-text" }, [
                _createElementVNode("i", { class: "bi bi-search" })
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.refreshDevices && _ctx.refreshDevices(...args))),
                class: "btn btn-light-primary me-2",
                disabled: _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                  : (_openBlock(), _createElementBlock("i", _hoisted_20)),
                _cache[50] || (_cache[50] = _createTextVNode(" Refresh ", -1))
              ], 8, _hoisted_18),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.exportToCSV && _ctx.exportToCSV(...args))),
                class: "btn btn-light-success",
                disabled: _ctx.devices.length === 0
              }, [...(_cache[51] || (_cache[51] = [
                _createElementVNode("i", { class: "bi bi-download me-2" }, null, -1),
                _createTextVNode(" Export CSV ", -1)
              ]))], 8, _hoisted_21)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, " Total: " + _toDisplayString(_ctx.deviceCount) + " | Online: " + _toDisplayString(_ctx.onlineDevices) + " | Offline: " + _toDisplayString(_ctx.offlineDevices), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("table", _hoisted_27, [
            _cache[66] || (_cache[66] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }, [
                _createElementVNode("th", { class: "min-w-125px" }, "ID Perangkat"),
                _createElementVNode("th", { class: "min-w-125px" }, "Nama"),
                _createElementVNode("th", { class: "min-w-125px" }, "Lokasi"),
                _createElementVNode("th", { class: "min-w-100px" }, "Walet Hari Ini"),
                _createElementVNode("th", { class: "min-w-125px" }, "Stream Key"),
                _createElementVNode("th", { class: "min-w-125px" }, "Status"),
                _createElementVNode("th", { class: "min-w-150px" }, "Siaran / AI"),
                _createElementVNode("th", { class: "min-w-150px" }, "Pemilik"),
                _createElementVNode("th", { class: "min-w-125px" }, "Dibuat"),
                _createElementVNode("th", { class: "text-end min-w-200px" }, "Aksi")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_28, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [...(_cache[52] || (_cache[52] = [
                    _createElementVNode("td", {
                      colspan: "10",
                      class: "text-center py-5"
                    }, [
                      _createElementVNode("div", {
                        class: "spinner-border",
                        role: "status"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                      ])
                    ], -1)
                  ]))]))
                : (_ctx.filteredDevices.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[55] || (_cache[55] = _createElementVNode("i", {
                            class: "bi bi-hdd-network text-muted mb-3",
                            style: {"font-size":"3rem"}
                          }, null, -1)),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.searchQuery
                      ? "Tidak ada perangkat yang ditemukan"
                      : "Belum ada perangkat yang terdaftar"), 1),
                          (!_ctx.searchQuery)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("button", {
                                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openAddDeviceModal && _ctx.openAddDeviceModal(...args))),
                                  class: "btn btn-sm btn-primary"
                                }, [...(_cache[53] || (_cache[53] = [
                                  _createElementVNode("i", { class: "bi bi-plus-circle me-1" }, null, -1),
                                  _createTextVNode(" Daftar Perangkat Baru ", -1)
                                ]))]),
                                _createElementVNode("button", {
                                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openImportDeviceModal && _ctx.openImportDeviceModal(...args))),
                                  class: "btn btn-sm btn-success"
                                }, [...(_cache[54] || (_cache[54] = [
                                  _createElementVNode("i", { class: "bi bi-plus-circle me-1" }, null, -1),
                                  _createTextVNode(" Tambah yang Sudah Ada ", -1)
                                ]))])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.paginatedDevices, (device) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: device.id,
                        class: _normalizeClass({
                'highlighted-row': String(device.id) === _ctx.highlightedId,
              })
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("span", _hoisted_38, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/electronics/elc004.svg" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, _toDisplayString(device.id), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(device.name || "-"), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString(device.location || "-"), 1),
                            (device.city || device.province)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString([device.city, device.province].filter(Boolean).join(", ")), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          (_ctx.birdCounts[device.id])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("span", _hoisted_46, [
                                  _cache[56] || (_cache[56] = _createElementVNode("i", { class: "bi bi-box-arrow-in-down me-1" }, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.birdCounts[device.id].in), 1)
                                ]),
                                _createElementVNode("span", _hoisted_47, [
                                  _cache[57] || (_cache[57] = _createElementVNode("i", { class: "bi bi-box-arrow-up me-1" }, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.birdCounts[device.id].out), 1)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_48, "-"))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.maskStreamKey(device.stream_key)), 1),
                            _createElementVNode("button", {
                              class: "btn btn-icon btn-sm btn-light-primary",
                              onClick: ($event: any) => (_ctx.copyStreamKey(device.stream_key)),
                              title: "Copy Stream Key"
                            }, [...(_cache[58] || (_cache[58] = [
                              _createElementVNode("i", { class: "bi bi-clipboard" }, null, -1)
                            ]))], 8, _hoisted_51)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          (device.stream_enabled === false)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, [...(_cache[59] || (_cache[59] = [
                                _createElementVNode("i", { class: "bi bi-power me-1" }, null, -1),
                                _createTextVNode("Diputus ", -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(_ctx.getStatusBadgeClass(device.status))
                              }, _toDisplayString(_ctx.getStatusText(device.status)), 3))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("input", {
                              class: "form-check-input h-20px w-30px",
                              type: "checkbox",
                              checked: device.stream_enabled !== false,
                              disabled: _ctx.streamBusy[device.id],
                              onChange: ($event: any) => (_ctx.toggleStream(device)),
                              id: `stream-${device.id}`
                            }, null, 40, _hoisted_54),
                            _createElementVNode("label", {
                              class: "form-check-label fs-8 text-gray-700",
                              for: `stream-${device.id}`
                            }, [
                              (_ctx.streamBusy[device.id])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56))
                                : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(device.stream_enabled === false ? "Siaran mati" : "Siaran"), 1))
                            ], 8, _hoisted_55)
                          ]),
                          (_ctx.isTuyaDevice(device))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "form-check form-switch form-check-custom form-check-solid",
                                title: 
                    device.stream_enabled === false
                      ? 'Aktifkan siaran dulu'
                      : 'Overlay AI penghitung walet. Matikan untuk siaran langsung tanpa overlay.'
                  
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input h-20px w-30px",
                                  type: "checkbox",
                                  checked: device.cv_enabled !== false,
                                  disabled: 
                      _ctx.cvBusy[device.id] || device.stream_enabled === false
                    ,
                                  onChange: ($event: any) => (_ctx.toggleCv(device)),
                                  id: `cv-${device.id}`
                                }, null, 40, _hoisted_59),
                                _createElementVNode("label", {
                                  class: "form-check-label fs-8 text-gray-700",
                                  for: `cv-${device.id}`
                                }, [
                                  (_ctx.cvBusy[device.id])
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_61))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_62, "Overlay AI"))
                                ], 8, _hoisted_60)
                              ], 8, _hoisted_58))
                            : (_openBlock(), _createElementBlock("span", _hoisted_63, "Non-Tuya"))
                        ]),
                        _createElementVNode("td", null, [
                          (device.owner_uid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _createElementVNode("span", _hoisted_65, _toDisplayString(device.owner_name || device.owner_email || "—"), 1),
                                (device.owner_name && device.owner_email)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_66, _toDisplayString(device.owner_email), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_67, "Belum ditetapkan"))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.formatDate(device.created_at)), 1),
                            (device.lastSeen)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, " Last seen: " + _toDisplayString(_ctx.formatRelativeTime(device.lastSeen)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_71, [
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1",
                            onClick: ($event: any) => (_ctx.watchDevice(device)),
                            title: "Tonton Siaran Langsung"
                          }, [...(_cache[60] || (_cache[60] = [
                            _createElementVNode("i", { class: "bi bi-play-circle-fill fs-4" }, null, -1)
                          ]))], 8, _hoisted_72),
                          _createVNode(_component_router_link, {
                            to: `/iot/devices/${device.id}`,
                            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                            title: "Detail & Jadwal Streaming"
                          }, {
                            default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                              _createElementVNode("i", { class: "bi bi-calendar-week fs-5" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                            onClick: ($event: any) => (_ctx.viewDevice(device)),
                            title: "Lihat Detail"
                          }, [
                            _createElementVNode("span", _hoisted_74, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                            ])
                          ], 8, _hoisted_73),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1",
                            onClick: ($event: any) => (_ctx.openAssignOwner(device)),
                            title: "Tetapkan Pemilik"
                          }, [...(_cache[62] || (_cache[62] = [
                            _createElementVNode("i", { class: "bi bi-person-gear fs-5" }, null, -1)
                          ]))], 8, _hoisted_75),
                          (_ctx.isTuyaDevice(device))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1",
                                onClick: ($event: any) => (_ctx.openHandoff(device)),
                                title: "Serahkan ke Pemilik"
                              }, [...(_cache[63] || (_cache[63] = [
                                _createElementVNode("i", { class: "bi bi-person-check fs-5" }, null, -1)
                              ]))], 8, _hoisted_76))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                            onClick: ($event: any) => (_ctx.editDevice(device)),
                            title: "Edit Perangkat"
                          }, [
                            _createElementVNode("span", _hoisted_78, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                            ])
                          ], 8, _hoisted_77),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1",
                            onClick: ($event: any) => (_ctx.handleTestConnection(device)),
                            title: "Test Koneksi"
                          }, [
                            _createElementVNode("span", _hoisted_80, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com012.svg" })
                            ])
                          ], 8, _hoisted_79),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-1",
                            onClick: ($event: any) => (_ctx.handleRegenerateStreamKey(device)),
                            title: "Generate Ulang Stream Key"
                          }, [
                            _createElementVNode("span", _hoisted_82, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen013.svg" })
                            ])
                          ], 8, _hoisted_81),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1",
                            onClick: ($event: any) => (_ctx.confirmResetBirdCount(device)),
                            title: "Reset Counter Hari Ini ke 0"
                          }, [...(_cache[64] || (_cache[64] = [
                            _createElementVNode("i", { class: "bi bi-arrow-counterclockwise fs-4" }, null, -1)
                          ]))], 8, _hoisted_83),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-1",
                            onClick: ($event: any) => (_ctx.confirmClearAllData(device)),
                            title: "Hapus SEMUA Data Hitung (mulai bersih)"
                          }, [...(_cache[65] || (_cache[65] = [
                            _createElementVNode("i", { class: "bi bi-eraser fs-4" }, null, -1)
                          ]))], 8, _hoisted_84),
                          _createElementVNode("button", {
                            class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm",
                            onClick: ($event: any) => (_ctx.confirmDeleteDevice(device)),
                            title: "Hapus Perangkat"
                          }, [
                            _createElementVNode("span", _hoisted_86, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                            ])
                          ], 8, _hoisted_85)
                        ])
                      ], 2))
                    }), 128))
            ])
          ])
        ]),
        (_ctx.filteredDevices.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("span", _hoisted_89, " Menampilkan " + _toDisplayString((_ctx.currentPage - 1) * _ctx.pageSize + 1) + " - " + _toDisplayString(Math.min(_ctx.currentPage * _ctx.pageSize, _ctx.filteredDevices.length)) + " dari " + _toDisplayString(_ctx.filteredDevices.length) + " perangkat ", 1)
              ]),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("ul", _hoisted_91, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                    }, [...(_cache[67] || (_cache[67] = [
                      _createElementVNode("span", { class: "previous" }, null, -1)
                    ]))])
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: page,
                      class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                    }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
                      }, _toDisplayString(page), 9, _hoisted_92)
                    ], 2))
                  }), 128)),
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                    }, [...(_cache[68] || (_cache[68] = [
                      _createElementVNode("span", { class: "next" }, null, -1)
                    ]))])
                  ], 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h5", _hoisted_97, _toDisplayString(_ctx.isEditing ? "Edit Perangkat IoT" : "Tambah Perangkat IoT Baru"), 1),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("span", _hoisted_99, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_100, [
            (_ctx.isEditing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _cache[71] || (_cache[71] = _createElementVNode("i", { class: "bi bi-info-circle me-2" }, null, -1)),
                  _createElementVNode("small", null, [
                    (_ctx.deviceApiService.hasAdminKey())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_102, [...(_cache[69] || (_cache[69] = [
                          _createElementVNode("strong", null, "Mode Server:", -1),
                          _createTextVNode(" Perubahan akan disimpan ke server dan sinkron otomatis. ", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_103, [...(_cache[70] || (_cache[70] = [
                          _createElementVNode("strong", null, "Mode Lokal:", -1),
                          _createTextVNode(" Perubahan hanya disimpan di browser. Untuk sinkron server, hubungi administrator. ", -1)
                        ]))]))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitDevice && _ctx.submitDevice(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_104, [
                _cache[73] || (_cache[73] = _createElementVNode("label", { class: "form-label" }, "Nama Perangkat", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.deviceForm.name) = $event)),
                  placeholder: "Masukkan nama perangkat (opsional)"
                }, null, 512), [
                  [_vModelText, _ctx.deviceForm.name]
                ]),
                _createElementVNode("div", _hoisted_105, [
                  _cache[72] || (_cache[72] = _createTextVNode(" Nama untuk memudahkan identifikasi perangkat ", -1)),
                  (_ctx.isEditing && !_ctx.deviceApiService.hasAdminKey())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_106, " (perubahan hanya tersimpan lokal) "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _cache[75] || (_cache[75] = _createElementVNode("label", { class: "form-label" }, "Lokasi", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.deviceForm.location) = $event)),
                  placeholder: "Masukkan lokasi perangkat (opsional)"
                }, null, 512), [
                  [_vModelText, _ctx.deviceForm.location]
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _cache[74] || (_cache[74] = _createTextVNode(" Lokasi fisik perangkat ", -1)),
                  (_ctx.isEditing && !_ctx.deviceApiService.hasAdminKey())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_109, " (perubahan hanya tersimpan lokal) "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _cache[76] || (_cache[76] = _createElementVNode("label", { class: "form-label" }, "Kota", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.deviceForm.city) = $event)),
                    placeholder: "Kota (opsional)"
                  }, null, 512), [
                    [_vModelText, _ctx.deviceForm.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_112, [
                  _cache[77] || (_cache[77] = _createElementVNode("label", { class: "form-label" }, "Provinsi", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.deviceForm.province) = $event)),
                    placeholder: "Provinsi (opsional)"
                  }, null, 512), [
                    [_vModelText, _ctx.deviceForm.province]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _cache[78] || (_cache[78] = _createElementVNode("label", { class: "form-label" }, "Password", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.deviceForm.password) = $event)),
                  placeholder: 
                  _ctx.isEditing
                    ? 'Kosongkan jika tidak ingin mengubah password'
                    : 'Masukkan password untuk perangkat'
                ,
                  required: !_ctx.isEditing
                }, null, 8, _hoisted_114), [
                  [_vModelText, _ctx.deviceForm.password]
                ]),
                _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.isEditing
                    ? "Password digunakan untuk autentikasi perangkat"
                    : "Password akan digunakan untuk autentikasi perangkat"), 1)
              ]),
              (_ctx.deviceForm.stream_key)
                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                    _cache[80] || (_cache[80] = _createElementVNode("label", { class: "form-label" }, "Stream Key", -1)),
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        value: _ctx.deviceForm.stream_key,
                        readonly: ""
                      }, null, 8, _hoisted_118),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-light",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.copyStreamKey(_ctx.deviceForm.stream_key)))
                      }, [...(_cache[79] || (_cache[79] = [
                        _createElementVNode("i", { class: "bi bi-clipboard" }, null, -1)
                      ]))])
                    ]),
                    _cache[81] || (_cache[81] = _createElementVNode("div", { class: "form-text" }, " Stream key akan digunakan untuk streaming data ", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_119, [
                _cache[82] || (_cache[82] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light me-3",
                  "data-bs-dismiss": "modal"
                }, " Batal ", -1)),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.submitting
                }, [
                  (_ctx.submitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_121))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? "Update Perangkat" : "Simpan Perangkat"), 1)
                ], 8, _hoisted_120)
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_122, [
      _createElementVNode("div", _hoisted_123, [
        _createElementVNode("div", _hoisted_124, [
          _createElementVNode("div", _hoisted_125, [
            _cache[83] || (_cache[83] = _createElementVNode("h5", { class: "modal-title" }, "Tambah Perangkat yang Sudah Ada", -1)),
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("span", _hoisted_127, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_128, [
            _cache[90] || (_cache[90] = _createElementVNode("div", {
              class: "alert alert-info d-flex align-items-center",
              role: "alert"
            }, [
              _createElementVNode("i", { class: "bi bi-info-circle me-2" }),
              _createElementVNode("small", null, " Gunakan fitur ini untuk menambahkan perangkat IoT yang sudah terdaftar sebelumnya ke dalam manajemen perangkat. ")
            ], -1)),
            _createElementVNode("form", {
              onSubmit: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.importDevice && _ctx.importDevice(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_129, [
                _cache[84] || (_cache[84] = _createElementVNode("label", { class: "form-label required" }, "ID Perangkat", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.importForm.deviceId) = $event)),
                  placeholder: "Masukkan ID perangkat",
                  required: "",
                  min: "1"
                }, null, 512), [
                  [_vModelText, _ctx.importForm.deviceId]
                ]),
                _cache[85] || (_cache[85] = _createElementVNode("div", { class: "form-text" }, " ID perangkat yang didapat saat registrasi perangkat ", -1))
              ]),
              _createElementVNode("div", _hoisted_130, [
                _cache[86] || (_cache[86] = _createElementVNode("label", { class: "form-label required" }, "Password", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.importForm.password) = $event)),
                  placeholder: "Masukkan password perangkat",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.importForm.password]
                ]),
                _cache[87] || (_cache[87] = _createElementVNode("div", { class: "form-text" }, " Password yang digunakan saat registrasi perangkat ", -1))
              ]),
              _createElementVNode("div", _hoisted_131, [
                _cache[89] || (_cache[89] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light me-3",
                  "data-bs-dismiss": "modal"
                }, " Batal ", -1)),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.importing
                }, [
                  (_ctx.importing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_133))
                    : (_openBlock(), _createElementBlock("i", _hoisted_134)),
                  _cache[88] || (_cache[88] = _createTextVNode(" Tambah Perangkat ", -1))
                ], 8, _hoisted_132)
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_135, [
      _createElementVNode("div", _hoisted_136, [
        _createElementVNode("div", _hoisted_137, [
          _createElementVNode("div", _hoisted_138, [
            _cache[91] || (_cache[91] = _createElementVNode("h5", { class: "modal-title" }, "Detail Perangkat IoT", -1)),
            _createElementVNode("div", _hoisted_139, [
              _createElementVNode("span", _hoisted_140, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          (_ctx.viewingDevice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _createElementVNode("div", _hoisted_144, [
                      _createElementVNode("div", _hoisted_145, [
                        _createElementVNode("div", _hoisted_146, [
                          _createElementVNode("div", _hoisted_147, [
                            _createElementVNode("span", _hoisted_148, [
                              _createElementVNode("span", _hoisted_149, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/electronics/elc004.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_150, [
                            _createElementVNode("div", _hoisted_151, [
                              _cache[92] || (_cache[92] = _createElementVNode("span", { class: "fs-5 text-gray-800 fw-bold" }, "ID Perangkat", -1)),
                              _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.viewingDevice.id), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_153, [
                          _createElementVNode("div", _hoisted_154, [
                            _createElementVNode("span", _hoisted_155, [
                              _createElementVNode("span", _hoisted_156, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen015.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_157, [
                            _createElementVNode("div", _hoisted_158, [
                              _cache[93] || (_cache[93] = _createElementVNode("span", { class: "fs-5 text-gray-800 fw-bold" }, "Nama", -1)),
                              _createElementVNode("div", _hoisted_159, _toDisplayString(_ctx.viewingDevice.name || "Tidak ada nama"), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_160, [
                          _createElementVNode("div", _hoisted_161, [
                            _createElementVNode("span", _hoisted_162, [
                              _createElementVNode("span", _hoisted_163, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/maps/map004.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_164, [
                            _createElementVNode("div", _hoisted_165, [
                              _cache[94] || (_cache[94] = _createElementVNode("span", { class: "fs-5 text-gray-800 fw-bold" }, "Lokasi", -1)),
                              _createElementVNode("div", _hoisted_166, _toDisplayString(_ctx.viewingDevice.location || "Tidak ada lokasi"), 1),
                              (_ctx.viewingDevice.city || _ctx.viewingDevice.province)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_167, _toDisplayString([_ctx.viewingDevice.city, _ctx.viewingDevice.province]
                              .filter(Boolean)
                              .join(", ")), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("div", _hoisted_171, [
                          _createElementVNode("div", _hoisted_172, [
                            _createElementVNode("span", _hoisted_173, [
                              _createElementVNode("span", _hoisted_174, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com012.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_175, [
                            _createElementVNode("div", _hoisted_176, [
                              _cache[96] || (_cache[96] = _createElementVNode("span", { class: "fs-5 text-gray-800 fw-bold" }, "Stream Key", -1)),
                              _createElementVNode("div", _hoisted_177, [
                                _createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.maskStreamKey(_ctx.viewingDevice.stream_key)), 1),
                                _createElementVNode("button", {
                                  class: "btn btn-icon btn-sm btn-light-primary",
                                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.copyStreamKey(_ctx.viewingDevice.stream_key)))
                                }, [...(_cache[95] || (_cache[95] = [
                                  _createElementVNode("i", { class: "bi bi-clipboard" }, null, -1)
                                ]))])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_179, [
                          _createElementVNode("div", _hoisted_180, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["symbol-label", 
                          _ctx.getStatusBadgeClass(_ctx.viewingDevice.status).replace(
                            'badge',
                            'bg'
                          )
                        ])
                            }, [
                              _createElementVNode("span", _hoisted_181, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com012.svg" })
                              ])
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_182, [
                            _createElementVNode("div", _hoisted_183, [
                              _cache[97] || (_cache[97] = _createElementVNode("span", { class: "fs-5 text-gray-800 fw-bold" }, "Status", -1)),
                              _createElementVNode("div", _hoisted_184, _toDisplayString(_ctx.getStatusText(_ctx.viewingDevice.status)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_185, [
                          _createElementVNode("div", _hoisted_186, [
                            _createElementVNode("span", _hoisted_187, [
                              _createElementVNode("span", _hoisted_188, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen014.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_189, [
                            _createElementVNode("div", _hoisted_190, [
                              _cache[98] || (_cache[98] = _createElementVNode("span", { class: "fs-5 text-gray-800 fw-bold" }, "Dibuat", -1)),
                              _createElementVNode("div", _hoisted_191, _toDisplayString(_ctx.formatDate(_ctx.viewingDevice.created_at)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_192, [
                          _createElementVNode("div", _hoisted_193, [
                            _createElementVNode("span", _hoisted_194, [
                              _createElementVNode("span", _hoisted_195, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen014.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_196, [
                            _createElementVNode("div", _hoisted_197, [
                              _cache[99] || (_cache[99] = _createElementVNode("span", { class: "fs-5 text-gray-800 fw-bold" }, "Diperbarui", -1)),
                              _createElementVNode("div", _hoisted_198, _toDisplayString(_ctx.formatDate(_ctx.viewingDevice.updated_at)), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _cache[100] || (_cache[100] = _createElementVNode("div", { class: "text-end" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal"
                  }, " Tutup ")
                ], -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_199, [
      _createElementVNode("div", _hoisted_200, [
        _createElementVNode("div", _hoisted_201, [
          _createElementVNode("div", _hoisted_202, [
            _cache[101] || (_cache[101] = _createElementVNode("h5", { class: "modal-title" }, "Konfirmasi Hapus", -1)),
            _createElementVNode("div", _hoisted_203, [
              _createElementVNode("span", _hoisted_204, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_205, [
            _createElementVNode("div", _hoisted_206, [
              _createElementVNode("span", _hoisted_207, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
              ]),
              _createElementVNode("div", _hoisted_208, [
                _cache[104] || (_cache[104] = _createElementVNode("h3", null, "Apakah Anda yakin?", -1)),
                _createElementVNode("p", _hoisted_209, [
                  _cache[102] || (_cache[102] = _createTextVNode(" Perangkat ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.deviceToDelete?.name || _ctx.deviceToDelete?.id), 1),
                  _cache[103] || (_cache[103] = _createTextVNode(" akan dihapus permanen dan tidak dapat dikembalikan. ", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_210, [
            _cache[106] || (_cache[106] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal"
            }, " Batal ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteDevice && _ctx.handleDeleteDevice(...args))),
              disabled: _ctx.deleting
            }, [
              (_ctx.deleting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_212))
                : _createCommentVNode("", true),
              _cache[105] || (_cache[105] = _createTextVNode(" Ya, Hapus ", -1))
            ], 8, _hoisted_211)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_213, [
      _createElementVNode("div", _hoisted_214, [
        _createElementVNode("div", _hoisted_215, [
          _createElementVNode("div", _hoisted_216, [
            _cache[107] || (_cache[107] = _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "bi bi-qr-code me-2" }),
              _createTextVNode("Pasangkan Kamera Bardi A50 ")
            ], -1)),
            _createElementVNode("div", _hoisted_217, [
              _createElementVNode("span", _hoisted_218, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_219, [
            (_ctx.pairStep === 'form')
              ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                  _cache[113] || (_cache[113] = _createElementVNode("p", { class: "text-muted fs-7 mb-4" }, " Masukkan WiFi rumah (khusus 2.4 GHz). Kamera akan menjadi milik akun Anda. Tanpa app Bardi/Tuya. ", -1)),
                  _createElementVNode("div", _hoisted_221, [
                    _cache[108] || (_cache[108] = _createElementVNode("label", { class: "form-label required" }, "Nama WiFi (SSID) — 2.4 GHz", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.pairSsid) = $event)),
                      placeholder: "contoh: RBW-Lantai2"
                    }, null, 512), [
                      [_vModelText, _ctx.pairSsid]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_222, [
                    _cache[109] || (_cache[109] = _createElementVNode("label", { class: "form-label" }, "Password WiFi", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.pairPwd) = $event)),
                      placeholder: "password WiFi"
                    }, null, 512), [
                      [_vModelText, _ctx.pairPwd]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_223, [
                    _cache[110] || (_cache[110] = _createElementVNode("label", { class: "form-label" }, "Nama Kamera (opsional)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.pairName) = $event)),
                      placeholder: "cth: RBW Lantai 2 - Timur"
                    }, null, 512), [
                      [_vModelText, _ctx.pairName]
                    ]),
                    _cache[111] || (_cache[111] = _createElementVNode("div", { class: "form-text fs-8" }, " Diisi otomatis ke perangkat setelah terpasang. Kosongkan untuk memakai nama bawaan. ", -1))
                  ]),
                  (_ctx.pairError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_224, _toDisplayString(_ctx.pairError), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-primary w-100",
                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.generatePairing && _ctx.generatePairing(...args))),
                    disabled: _ctx.pairLoading || !_ctx.pairSsid
                  }, [
                    (_ctx.pairLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_226))
                      : _createCommentVNode("", true),
                    _cache[112] || (_cache[112] = _createTextVNode(" Buat QR Pairing ", -1))
                  ], 8, _hoisted_225)
                ]))
              : (_ctx.pairStep === 'qr')
                ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                    _createElementVNode("div", _hoisted_228, [
                      _createVNode(_component_qrcode_vue, {
                        value: _ctx.pairQrValue,
                        size: 240,
                        level: "M"
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_229, _toDisplayString(_ctx.pairExpiryText), 1),
                    _cache[114] || (_cache[114] = _createElementVNode("ol", { class: "text-start fs-8 text-gray-700 mt-3" }, [
                      _createElementVNode("li", null, " Colok kamera, tunggu lampu berkedip cepat (reset bila perlu). "),
                      _createElementVNode("li", null, "Naikkan kecerahan layar ke maksimum."),
                      _createElementVNode("li", null, [
                        _createTextVNode("Arahkan "),
                        _createElementVNode("b", null, "lensa kamera"),
                        _createTextVNode(" ke QR ini (±15–20 cm).")
                      ]),
                      _createElementVNode("li", null, "Tahan sampai kamera berbunyi \"bip\".")
                    ], -1)),
                    _cache[115] || (_cache[115] = _createElementVNode("div", { class: "text-muted fs-8" }, [
                      _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }),
                      _createTextVNode(" Menunggu kamera terhubung… ")
                    ], -1)),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-light mt-3",
                      onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.generatePairing && _ctx.generatePairing(...args))),
                      disabled: _ctx.pairLoading
                    }, " Buat Ulang QR ", 8, _hoisted_230)
                  ]))
                : (_ctx.pairStep === 'done')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                      _cache[117] || (_cache[117] = _createElementVNode("div", { style: {"font-size":"48px"} }, "✅", -1)),
                      _createElementVNode("h4", _hoisted_232, _toDisplayString(_ctx.pairedDevice?.re_paired
                  ? "Kamera terhubung kembali!"
                  : "Kamera berhasil dipasangkan!"), 1),
                      _createElementVNode("p", _hoisted_233, _toDisplayString(_ctx.pairedDevice?.name || "Kamera #" + _ctx.pairedDevice?.id), 1),
                      _createElementVNode("div", _hoisted_234, [
                        _cache[116] || (_cache[116] = _createElementVNode("i", { class: "bi bi-broadcast me-1" }, null, -1)),
                        (_ctx.pairedDevice?.re_paired)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_235, " Siaran berlanjut otomatis — tidak perlu tindakan tambahan. "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_236, " Siaran akan aktif otomatis dalam ±1–2 menit (server memprovision worker sendiri). Kamera ini menjadi milik akun Anda. "))
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-primary w-100",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.finishPairing && _ctx.finishPairing(...args)))
                      }, " Selesai ")
                    ]))
                  : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_237, [
      _createElementVNode("div", _hoisted_238, [
        _createElementVNode("div", _hoisted_239, [
          _createElementVNode("div", _hoisted_240, [
            _cache[118] || (_cache[118] = _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "bi bi-person-gear me-2" }),
              _createTextVNode("Tetapkan Pemilik Perangkat ")
            ], -1)),
            _createElementVNode("div", _hoisted_241, [
              _createElementVNode("span", _hoisted_242, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          (_ctx.assigningDevice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                _createElementVNode("p", _hoisted_244, [
                  _cache[119] || (_cache[119] = _createTextVNode(" Perangkat ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.assigningDevice.name || "#" + _ctx.assigningDevice.id), 1),
                  _cache[120] || (_cache[120] = _createTextVNode(" hanya akan terlihat oleh pemiliknya (dan admin). Masukkan email akun pengguna untuk menetapkannya. ", -1))
                ]),
                _createElementVNode("div", _hoisted_245, [
                  _cache[121] || (_cache[121] = _createElementVNode("label", { class: "form-label" }, "Email Pemilik", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.assignEmail) = $event)),
                    placeholder: "cth: pemilik@email.com",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.assignEmail]
                  ]),
                  (_ctx.assigningDevice.owner_email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_246, " Saat ini: " + _toDisplayString(_ctx.assigningDevice.owner_email), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_247, [
                  (_ctx.assigningDevice.owner_uid)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-light-danger me-2",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.submitAssignOwner(true))),
                        disabled: _ctx.assigning
                      }, " Hapus Pemilik ", 8, _hoisted_248))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.submitAssignOwner(false))),
                    disabled: _ctx.assigning || !_ctx.assignEmail
                  }, [
                    (_ctx.assigning)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_250))
                      : _createCommentVNode("", true),
                    _cache[122] || (_cache[122] = _createTextVNode(" Simpan ", -1))
                  ], 8, _hoisted_249)
                ]),
                _cache[125] || (_cache[125] = _createElementVNode("div", { class: "separator my-5" }, null, -1)),
                _cache[126] || (_cache[126] = _createElementVNode("h6", { class: "mb-1" }, [
                  _createElementVNode("i", { class: "bi bi-people me-2" }),
                  _createTextVNode("Bagikan Akses ke Pengguna Lain ")
                ], -1)),
                _cache[127] || (_cache[127] = _createElementVNode("p", { class: "text-muted fs-8 mb-3" }, " Pengguna ini bisa melihat & menonton kamera (tanpa mengubah pengaturan). Berlaku di web & aplikasi mobile. ", -1)),
                (_ctx.assigningDevice.shares && _ctx.assigningDevice.shares.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assigningDevice.shares, (s) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: s.uid,
                          class: "d-flex align-items-center justify-content-between bg-light rounded px-3 py-2 mb-2"
                        }, [
                          _createElementVNode("span", _hoisted_252, _toDisplayString(s.name || s.email || s.uid), 1),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-icon btn-active-color-danger",
                            title: "Cabut akses",
                            onClick: ($event: any) => (_ctx.removeShare(s.uid)),
                            disabled: _ctx.sharingBusy
                          }, [...(_cache[123] || (_cache[123] = [
                            _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                          ]))], 8, _hoisted_253)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_254, " Belum dibagikan ke siapa pun. ")),
                _createElementVNode("div", _hoisted_255, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.shareEmail) = $event)),
                    placeholder: "email pengguna untuk dibagikan",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.shareEmail]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-light-primary",
                    onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.addShare && _ctx.addShare(...args))),
                    disabled: _ctx.sharingBusy || !_ctx.shareEmail
                  }, [
                    (_ctx.sharingBusy)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_257))
                      : _createCommentVNode("", true),
                    _cache[124] || (_cache[124] = _createTextVNode(" Bagikan ", -1))
                  ], 8, _hoisted_256)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_258, [
      _createElementVNode("div", _hoisted_259, [
        _createElementVNode("div", _hoisted_260, [
          _createElementVNode("div", _hoisted_261, [
            _cache[128] || (_cache[128] = _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "bi bi-person-check me-2" }),
              _createTextVNode("Serahkan Kamera ke Pemilik ")
            ], -1)),
            _createElementVNode("div", _hoisted_262, [
              _createElementVNode("span", _hoisted_263, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          (_ctx.handoffDevice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
                _createElementVNode("p", _hoisted_265, [
                  _cache[129] || (_cache[129] = _createTextVNode(" Serahkan kamera ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.handoffDevice.name || "#" + _ctx.handoffDevice.id), 1),
                  _cache[130] || (_cache[130] = _createTextVNode(" ke pengguna akhir. Kepemilikan berpindah ke email di bawah, lalu seluruh riwayat hitung QC dihapus agar pemilik mulai dari data bersih. ", -1))
                ]),
                _createElementVNode("div", _hoisted_266, [
                  _cache[131] || (_cache[131] = _createElementVNode("label", { class: "form-label required" }, "Email pemilik baru", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.handoffEmail) = $event)),
                    placeholder: "cth: pemilik@email.com",
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.handoffEmail]
                  ]),
                  (_ctx.handoffDevice.owner_email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_267, " Pemilik saat ini: " + _toDisplayString(_ctx.handoffDevice.owner_email), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_268, [
                  _cache[132] || (_cache[132] = _createElementVNode("label", { class: "form-label" }, "Nama perangkat", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.handoffName) = $event)),
                    placeholder: "Nama perangkat (opsional)"
                  }, null, 512), [
                    [_vModelText, _ctx.handoffName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_269, [
                  _cache[133] || (_cache[133] = _createElementVNode("label", { class: "form-label" }, "Lokasi", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.handoffLocation) = $event)),
                    placeholder: "Lokasi perangkat (opsional)"
                  }, null, 512), [
                    [_vModelText, _ctx.handoffLocation]
                  ])
                ]),
                _cache[135] || (_cache[135] = _createElementVNode("div", {
                  class: "alert alert-warning d-flex align-items-start",
                  role: "alert"
                }, [
                  _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2 mt-1" }),
                  _createElementVNode("small", null, [
                    _createElementVNode("strong", null, "Perhatian:"),
                    _createTextVNode(" Seluruh riwayat hitung QC untuk kamera ini akan "),
                    _createElementVNode("strong", null, "direset ke 0"),
                    _createTextVNode(" dan tidak dapat dikembalikan. ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_270, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light me-3",
                    "data-bs-dismiss": "modal",
                    disabled: _ctx.handoffBusy
                  }, " Batal ", 8, _hoisted_271),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.submitHandoff && _ctx.submitHandoff(...args))),
                    disabled: _ctx.handoffBusy || !_ctx.handoffEmail
                  }, [
                    (_ctx.handoffBusy)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_273))
                      : _createCommentVNode("", true),
                    _cache[134] || (_cache[134] = _createTextVNode(" Serahkan ", -1))
                  ], 8, _hoisted_272)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_274, [
      _createElementVNode("div", _hoisted_275, [
        _createElementVNode("div", _hoisted_276, [
          _createElementVNode("div", _hoisted_277, [
            _createElementVNode("h5", _hoisted_278, [
              _cache[136] || (_cache[136] = _createElementVNode("i", { class: "bi bi-camera-video me-2" }, null, -1)),
              _createTextVNode("Siaran Langsung — " + _toDisplayString(_ctx.watchingDevice
                ? _ctx.watchingDevice.name || "Perangkat #" + _ctx.watchingDevice.id
                : ""), 1)
            ]),
            _createElementVNode("div", _hoisted_279, [
              _createElementVNode("span", _hoisted_280, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          (_ctx.watchingDevice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_281, [
                _createVNode(_component_LiveStreamPlayer, {
                  "stream-key": _ctx.watchingDevice.stream_key,
                  "device-id": _ctx.watchingDevice.id,
                  mode: _ctx.watchPlayerMode,
                  active: _ctx.watchActive,
                  scheduled: _ctx.watchScheduled,
                  "schedule-active": _ctx.watchWithin,
                  "schedule-label": _ctx.watchScheduleLabel
                }, null, 8, ["stream-key", "device-id", "mode", "active", "scheduled", "schedule-active", "schedule-label"]),
                _createElementVNode("p", _hoisted_282, [
                  (_ctx.watchPlayerMode === 'off')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_283, [...(_cache[137] || (_cache[137] = [
                        _createElementVNode("i", { class: "bi bi-power me-1" }, null, -1),
                        _createTextVNode("Siaran kamera ini sedang diputus. Aktifkan kembali dari kolom \"Siaran / AI\" untuk menonton. ", -1)
                      ]))]))
                    : (_ctx.watchPlayerMode === 'direct')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_284, [
                          _cache[138] || (_cache[138] = _createElementVNode("i", { class: "bi bi-broadcast me-1" }, null, -1)),
                          (_ctx.watchOutsideWindow)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Di luar jam aktif — siaran langsung dari kamera (tanpa overlay AI) untuk hemat kuota. Overlay penghitung aktif otomatis saat jam terjadwal. ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" Siaran langsung dari kamera (tanpa overlay AI). ")
                              ], 64))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_285, " Overlay penghitung burung walet sudah menyatu di dalam siaran. ")),
                  (_ctx.watchingDevice.location)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_286, " Lokasi: " + _toDisplayString(_ctx.watchingDevice.location), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}